import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Flag } from "lucide-react";
import { moderationAPI } from "@/lib/api";
import { toast } from "sonner";

// Quiet, standard "report" action for marketplace / forum / social posts.
export default function ReportDialog({ contentType, contentId, trigger, className = "" }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    setSending(true);
    try {
      await moderationAPI.report({ content_type: contentType, content_id: contentId, reason });
      toast.success("Thanks, this post was sent for review.");
      setOpen(false);
      setReason("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not send the report.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {trigger ? (
        <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }} data-testid={`report-open-${contentId}`}>{trigger}</span>
      ) : (
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
          className={`inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground ${className}`}
          data-testid={`report-open-${contentId}`}
        >
          <Flag className="h-3.5 w-3.5" /> Report
        </button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Report this post</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">Tell us what is wrong. Our team reviews reports; the post stays live until a moderator decides.</p>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (optional)" data-testid="report-reason" />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={submit} disabled={sending} data-testid="report-submit">{sending ? "Sending..." : "Send report"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
